<template>
  <div class="lime-body">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
        <flash-message  id="flash-message" ></flash-message>
          <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-separator-1">
              <!--<li class="breadcrumb-item"><a href="#">Pages</a></li>-->
              <li class="breadcrumb-item active" aria-current="page">Brands</li>
            </ol>
          </nav>
         
            <div class="page-title">
               <h3>Brands List</h3>
               <div class="search-create">
                  <div class="search">
                    <input class="form-control mr-sm-2"  v-model="filter" @keydown="$event.stopImmediatePropagation()" type="text" placeholder="Search Brand" aria-label="Search" />
                  </div>
                  <button class="btn btn-primary" id="brandBtn" v-on:click="adbrand()"><i class="material-icons">add</i> Add Brand</button>
               </div>
            </div>
           
          </div>
        
      </div>
      <div class="row">
         <div class="col-md-12">
            <div class="table-responsive">
              <datatable :class="tblCls" :columns="columns" :filter="filter" ref="table" :per-page="10" :data="brandsList"></datatable>   
              <datatable-pager v-model="page" class="pagination"></datatable-pager>
            </div>
         </div>
      </div>
     
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import AddBrand from './AddBrand'
  import brandAction from './brandAction'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  require('vue-flash-message/dist/vue-flash-message.min.css')
  export default {
    name: 'Brands',
    components: { AddBrand,
      Loading
    },
    data () {
      return {
        checkExt: false,
        isLoading: false,
        errorMessage: '',
        fullPage: true,
        tblCls: 'table',
        brandsList: [],
        brands: [],
        errors: [],
        brandDetails: {
          brand_name: '',
          site_url: '',
          email: '',
          contact_no: '',
          uid: '',
          address: '',
          contact_title: '',
          contact_first_name: '',
          contact_last_name: '',
          contact_email: ''
        },
        


        columns: [
          {label: 'Stripe CustomerID', field: 'id'},
          {label: 'Brand Logo', field: '', interpolate: true, representedAs: row => ` <img style='height: 100px!important;height: 50px!important' src = '${row.brandlogo}'/> `, sortable: false},
          {label: 'Brand Name', field: 'brandname', headerClass: 'class-in-header second-class'},
          {label: 'Site Url', field: 'siteurl'},
          {label: 'Status', field: 'status'},
          {label: 'Action',
            component: brandAction,
            sortable: false
          }
        ],
        rows: this.brandsList,
        filter: '',
        page: 1,
        fileadd: '',
        fileedit: '',
        brandstatus: ''
      }
    },
    methods: {
    
      getBrands () {
        var jwttoken = localStorage.getItem('jwt')
        this.isLoading = true
        this.brandsList = [];
        axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
          headers: {
            'x-access-token': jwttoken
          }})
          .then(response => {
           
            this.brands = response.data.results
            for (var i in this.brands) {
              var obj = this.brands[i]
              this.brandsList.push({
                id: obj.stripe_customer_id,
                uid: obj.uid,
                brandlogo: obj.brand_logo,
                brandname: obj.brand_name,
                siteurl: obj.site_url,
                status: obj.status
              })
            }
             this.isLoading = false
          })
          .catch((error) => {
            this.errorMessage = error.response.data.errors
            this.isLoading = false
          })
      },
      adbrand () {
       this.$modal.show(AddBrand, { height: '100%' })
      },
      deactiveBrand (uid) {
        var jwttoken = localStorage.getItem('jwt')
        axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/deactivateBrand' + '?' + 'uid' + '=' + uid, {
          headers: {
            'x-access-token': jwttoken
          }})
          .then(response => {
            axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
              headers: {
                'x-access-token': jwttoken
              }})
              .then(response => {
                this.brands = response.data.results[0]
              })
          })
          .catch((error) => {
            this.errorMessage = error.response.data.errors
            this.isLoading = false
          })
      },
      activeBrand (uid) {
        var jwttoken = localStorage.getItem('jwt')
        axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/activateBrand' + '?' + 'uid' + '=' + uid, {
          headers: {
            'x-access-token': jwttoken
          }})
          .then(response => {
            axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
              headers: {
                'x-access-token': jwttoken
              }})
              .then(response => {
                this.brands = response.data.results[0]
              })
              .catch((error) => {
                this.errorMessage = error.response.data.errors
                this.isLoading = false
              })
          })
      },
    },
    created () { 
    },
    updated () { 
    },
    mounted () {    
        this.$eventBus.$on('listBrand', (data,error) => { 
          const messageStorage = this.flash();
          if (data) {  
             this.getBrands() ;
             this.$forceUpdate();
             messageStorage.destroyAll()
             this.flash(data, 'success', {timeout: 3000 });
          }
          else if (error) { 
          this.flashError(error);
          }
      }) 
    this.getBrands()      
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Brands.vue